import { NavLink } from "../../../components/ui/NavLink";
import { Category } from "@cabukaka/types";
import { useState } from "react";

interface CategoryCardProps {
  category: Category;
}

export function CategoryCard({ category }: CategoryCardProps) {
  const [imgError, setImgError] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);

  const defaultImage = "/images/category-placeholder.jpg";
  const targetImage = imgError ? defaultImage : category.image;

  return (
    <NavLink to={`/categories/${category.slug}`} className="block select-none flex-shrink-0">
      <div className="w-[130px] sm:w-[150px] md:w-[160px] cursor-pointer group flex flex-col items-center text-center">
        
        {/* LE CONTENEUR (Fond unique et harmonisé pour toute l'application) */}
        <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-gray-50/90 border border-gray-100/70 p-3 shadow-sm group-hover:shadow-md group-hover:border-orange-200/60 transition-all duration-300 ease-out flex items-center justify-center">
          
          {/* Loader discret */}
          {!imgLoaded && (
            <div className="absolute inset-0 bg-gray-100 animate-pulse rounded-2xl" />
          )}

          {/* Zone d'isolation de l'image */}
          <div className="relative w-full h-full flex items-center justify-center">
            <img
              src={targetImage}
              alt={category.name}
              loading="lazy"
              onLoad={() => imgLoaded === false && setImgLoaded(true)}
              onError={() => {
                setImgError(true);
                setImgLoaded(true);
              }}
              /* 
                L'ARME SECRÈTE : mix-blend-multiply
                Cette classe force l'arrière-plan de l'image (qu'il soit blanc, beige ou gris clair)
                à se fondre entièrement et à adopter le fond 'bg-gray-50' du conteneur.
                Le 'contrast-[1.02]' nettoie les faux-blancs (les blancs légèrement grisés).
              */
              className={`w-full h-full object-contain mix-blend-multiply contrast-[1.03] transition-all duration-500 ease-out group-hover:scale-105 ${
                imgLoaded ? "opacity-100" : "opacity-0"
              }`}
            />
          </div>

          {/* 
            Subtil filtre de lissage par-dessus :
            Si une image a un fond ultra-sombre qui résiste au 'multiply', ce voile uniforme
            les rapproche visuellement en adoucissant les angles.
          */}
          <div className="absolute inset-0 bg-black/[0.01] pointer-events-none rounded-2xl" />

          {/* Badge Populaire épuré */}
          {category.productCount > 100 && (
            <div className="absolute top-2 right-2 bg-white/80 backdrop-blur-md text-orange-600 text-[9px] font-bold px-2 py-0.5 rounded-lg border border-white shadow-sm">
              Top
            </div>
          )}
        </div>

        {/* CONTENU TEXTE */}
        <div className="mt-3 w-full px-0.5 space-y-0.5">
          <h4 className="text-xs md:text-sm font-bold text-gray-800 group-hover:text-orange-600 transition-colors duration-200 line-clamp-1">
            {category.name}
          </h4>
          
          <p className="text-[10px] md:text-xs font-medium text-gray-400">
            {category.productCount.toLocaleString()} produits
          </p>
        </div>

      </div>
    </NavLink>
  );
}